exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#message{\n  background-color: #E8E8E8;\n}\n\n.small-button {\n  font-size: 0.7em;\n}\n\n.search-span{\n    display:block;\n    width: 49em;\n    margin-top: 15px;\n    border-top: 1px solid #808080;\n}\n\n.orderWidth{\n  width: 49em;\n}\n\n.buttonsFormat {\n  float: right;\n}\n@media (max-width: 768px) {\n  .orderWidth{\n    width: 26.2em;\n  }\n  .search-span{\n    width: 26.2em;\n    margin-top: 55px;\n  }\n\n  .buttonsFormat {\n    float: left;\n    padding-top: 10px;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/orders/orders.component.css
// module id = ../../../../../src/app/orders/orders.component.css
// module chunks = main